import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { getervaringen } from "../Ervaringen/Reducers/actions";
import { saveboekingen, fetchboekingen, fetchboekingenfiltered } from "./Reducers/actions";
import { message, fixmessage } from "../../Reducers/loading/actions";
import BoekingenTabel from "./Components/boekingenDetails";

const BoekingenPage = ({ ervaring, fetchboekingen, fetchboekingenfiltered, boekingen }) => {
  const [loaded, setLoaded] = useState(false);
  const [status, setStatus] = useState("all");  // Start met alle statussen om te testen
  const [periode, setPeriode] = useState("last30days");  // Start met laatste 30 dagen
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [useCustomDates, setUseCustomDates] = useState(false);

  const loadBoekingen = () => {
    setLoaded(false);
    const filterData = {
      status: status,
      periode: !useCustomDates ? periode : null,
      dateFrom: useCustomDates ? dateFrom : null,
      dateTo: useCustomDates ? dateTo : null,
    };

    fetchboekingenfiltered(filterData).then((sdata) => {
      if (sdata && sdata.results) {
        setLoaded(true);
      } else {
        setLoaded(true); // Still show UI even if no results
      }
    }).catch((error) => {
      setLoaded(true);
    });
  };

  useEffect(() => {
    loadBoekingen();
  }, [status, periode, dateFrom, dateTo, useCustomDates]);

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <div className="box-title">
          <h2>Boekingen Overzicht</h2>
        </div>
        <div className="box-tools pull-right">
          <Link to="/ervaringen" className="btn btn-primary btn-sm float-right" role="group">
            Overzicht ervaringen
          </Link>
        </div>
      </div>

      <div className="box-body">
        {/* Filter Section */}
        <div className="row mb-4">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title mb-0">
                  <i className="fas fa-filter me-2"></i>
                  Filters
                </h5>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  {/* Status Filter */}
                  <div className="col-md-3">
                    <label className="form-label">Status</label>
                    <select 
                      className="form-select" 
                      value={status} 
                      onChange={(e) => setStatus(e.target.value)}
                    >
                      <option value="all">Alle statussen</option>
                      <option value="Nieuw">Nieuwe boekingen</option>
                      <option value="accept">Geaccepteerde boekingen</option>
                      <option value="cancel">Geannuleerde boekingen</option>
                      <option value="pending">In afwachting</option>
                      <option value="betaald">Betaalde boekingen</option>
                    </select>
                  </div>

                  {/* Period Type Toggle */}
                  <div className="col-md-3">
                    <label className="form-label">Datum filter type</label>
                    <select 
                      className="form-select" 
                      value={useCustomDates ? "custom" : "period"} 
                      onChange={(e) => setUseCustomDates(e.target.value === "custom")}
                    >
                      <option value="period">Vaste periodes</option>
                      <option value="custom">Aangepaste datums</option>
                    </select>
                  </div>

                  {/* Period Filter */}
                  {!useCustomDates && (
                    <div className="col-md-3">
                      <label className="form-label">Periode</label>
                      <select
                        className="form-select"
                        value={periode}
                        onChange={(e) => setPeriode(e.target.value)}
                      >
                        <option value="today">Vandaag</option>
                        <option value="week">Deze week</option>
                        <option value="last30days">Laatste 30 dagen</option>
                        <option value="month">Deze maand</option>
                        <option value="lastMonth">Afgelopen maand</option>
                        <option value="quarter">Dit kwartaal</option>
                        <option value="year">Dit jaar</option>
                      </select>
                    </div>
                  )}

                  {/* Custom Date Range */}
                  {useCustomDates && (
                    <>
                      <div className="col-md-3">
                        <label className="form-label">Van datum</label>
                        <input
                          type="date"
                          className="form-control"
                          value={dateFrom}
                          onChange={(e) => setDateFrom(e.target.value)}
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Tot datum</label>
                        <input
                          type="date"
                          className="form-control"
                          value={dateTo}
                          onChange={(e) => setDateTo(e.target.value)}
                        />
                      </div>
                    </>
                  )}

                  {/* Refresh Button */}
                  <div className="col-md-3 d-flex align-items-end">
                    <button 
                      className="btn btn-primary w-100"
                      onClick={loadBoekingen}
                      disabled={!loaded}
                    >
                      <i className="fas fa-sync-alt me-2"></i>
                      Vernieuwen
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Results */}
        {loaded ? (
          <div className="box-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">
                Resultaten ({boekingen?.length || 0} boekingen)
              </h5>
              <small className="text-muted">
                Filter: {status === 'all' ? 'Alle statussen' : status} • 
                {useCustomDates 
                  ? ` ${dateFrom || 'Begin'} - ${dateTo || 'Einde'}`
                  : ` ${periode.charAt(0).toUpperCase() + periode.slice(1)}`
                }
              </small>
            </div>
            <BoekingenTabel boekingen={boekingen} />
          </div>
        ) : (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2 text-muted">Boekingen laden...</p>
          </div>
        )}
      </div>
    </div>
  );
};
function mapStateToProps(state) {
  return { username: state.auth.user, ervaring: state.ervaringen.item, boekingen: state.boekingen.items };
}

export default connect(mapStateToProps, {
  message,
  fixmessage,
  getervaringen,
  saveboekingen,
  fetchboekingen,
  fetchboekingenfiltered,
})(BoekingenPage);
